export enum KeyboardEventKey {
	ARROW_DOWN = 'ArrowDown',
	ARROW_UP = 'ArrowUp',
	ESCAPE = 'Escape',
	ENTER = 'Enter',
}
